if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      /**
       * 构造函数 - 初始化粘性添加到购物车组件
       * 设置DOM选择器配置和检查自定义字段
       */
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
        this.addToCartWrapperDom = null;
      }

      /**
       * 组件连接回调 - 当组件被添加到DOM时执行
       * 初始化所有必要的DOM引用、事件监听器和组件状态
       */
      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));


        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      /**
       * 获取变体数据 - 从JSON元素中解析产品变体信息
       * @returns {Array} 产品变体数据数组
       */
      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      /**
       * 初始化函数 - 设置粘性按钮的核心功能
       * 包括动画效果、交叉观察器、事件监听器和自定义字段验证
       */
      init() {

        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        if (buyNowBtn) this.enable_dynamic_checkout = true;
        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;



        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();

        this.initAddToCartWrapper();
      }


      initAddToCartWrapper() {
        document.addEventListener('DOMContentLoaded', () => {
          let isLogicExecuted = false;
          let lastScrollY = window.scrollY;
          let scrollDirection = 'down';
          let isTicking = false;
          const stickyBar = document.querySelector('.m-sticky-addtocart');

        
          // --- 滚动方向检测模块 (保持不变) ---
          const updateScrollDirection = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY) {
              scrollDirection = 'down';
            } else if (currentScrollY < lastScrollY) {
              scrollDirection = 'up';
            }
            lastScrollY = currentScrollY;
            isTicking = false;
          };
        
          window.addEventListener('scroll', () => {
            if (!isTicking) {
              window.requestAnimationFrame(updateScrollDirection);
              isTicking = true;
            }
          });
        
          // --- addToCartWrapper (保持不变) ---
          const addToCartWrapper = (button) => {
            if (!button) return null;
            if (button.parentNode.classList.contains('add-to-cart-wrapper')) {
              return button.parentNode;
            }
            const wrapper = document.createElement("div");
            const sentinelTop = document.createElement('div');
            sentinelTop.classList.add('sentinel-top');
            const sentinelBottom = document.createElement('div');
            sentinelBottom.classList.add('sentinel-bottom');
            wrapper.classList.add("add-to-cart-wrapper");
            button.parentNode.insertBefore(wrapper, button);
            wrapper.appendChild(sentinelTop);
            wrapper.appendChild(button);
            wrapper.appendChild(sentinelBottom);
            wrapper.style.minHeight = `${button.offsetHeight}px`;
            console.log('✅ Wrapper 和哨兵已成功创建并包裹按钮！');
            return wrapper;
          };
        
          
          const startIntersectionObserver = (wrapper, button) => {
            if (!wrapper || !button) return;
            
          
        
            const sentinelTop = wrapper.querySelector('.sentinel-top');
            const sentinelBottom = wrapper.querySelector('.sentinel-bottom');
            const stickyAncestor = document.querySelector('.m-product-info--wrapper');
            
            if (!sentinelTop || !sentinelBottom || !stickyAncestor) {
              console.error("启动观察者失败：关键元素缺失。");
              return;
            }

            const setStickyOn = () => {
              if (!button.classList.contains('is-sticky')) {
                stickyBar.classList.add('sticky-show');
                setTimeout(() => {
                  setButton()
                }, 0);
                console.log('⚡️ Sticky ON');
              }
            };
        
            const setStickyOff = () => {
              if (button.classList.contains('is-sticky')) {
                stickyBar.classList.remove('sticky-show');
                button.classList.remove('is-sticky');
                console.log('🔌 Sticky OFF');
              }
            };
            
            // 【！！！全新的、只信任最终状态的回调！！！】
            const handleIntersection = (entries) => {
              // 找到针对 sentinelTop 的最后一个 entry
              const lastTopEntry = entries.filter(e => e.target === sentinelTop).pop();
              // 找到针对 sentinelBottom 的最后一个 entry
              const lastBottomEntry = entries.filter(e => e.target === sentinelBottom).pop();

              // --- 决策逻辑 ---
              if (lastTopEntry && lastTopEntry.isIntersecting) {
                // 规则1：只要顶部哨兵可见，就关闭sticky
                setStickyOff();
                return;
              }
              
              if (lastBottomEntry && !lastBottomEntry.isIntersecting && lastBottomEntry.boundingClientRect.bottom < 0) {
                // 规则2：如果底部哨兵从顶部消失，开启sticky
                setStickyOn();
                return;
              }
              
              if (lastTopEntry && !lastTopEntry.isIntersecting && lastTopEntry.boundingClientRect.top > window.innerHeight) {
                // 规则3：如果顶部哨兵从底部消失，开启sticky
                setStickyOn();
                return;
              }
            };

            const observer = new IntersectionObserver(handleIntersection, {
              root: null,
              rootMargin: '0px',
              threshold: [0, 1] // 使用数组可以更精确地捕捉进入和离开的瞬间
            });
            
            // 你的 checkInitialState 和 setButton 函数 (稍作修正)
            const checkInitialState = () => {
              console.log('初始化，滚动到顶部然后第一次加上sticky', stickyBar); 
              stickyBar.classList.add('sticky-show');
              setTimeout(() => {
                setButton()
              }, 0);
            };
        
            const setButton = () => {
              button.classList.add('is-sticky');
              const rect = document.querySelector('.for-add-to-cart-button').getBoundingClientRect();
              button.style.left = `${rect.x}px`;
              button.style.top = `${rect.y}px`;
            }

            window.addEventListener('resize', () => {
              if (stickyBar.className.includes('sticky-show')) {
                setTimeout(() => {
                  setButton()
                }, 0);
              }
            });

            checkInitialState();
            
            setTimeout(() => {
              observer.observe(sentinelTop);
              observer.observe(sentinelBottom);
              
              console.log('✅ 带“防抖”的“分离观察者”系统已启动。');
            }, 500);
          };
          
          // ... 后续所有代码保持和你提供的一模一样 ...
          const runStickyLogic = () => {
            if (isLogicExecuted) return;
            isLogicExecuted = true;
            console.log('🚀 首次执行核心逻辑...');
            const nativeButton = document.querySelector(".copy-to-sticky");
            const wrapper = addToCartWrapper(nativeButton);
            startIntersectionObserver(wrapper, nativeButton);
          };
          const nativeButton = document.querySelector(".copy-to-sticky");
          const formWrapper = document.querySelector(".m-product-form--wrapper");
          if (!nativeButton || !formWrapper) return;
          const enhancedMutationCallback = (mutationsList, observer) => {
            const pluginLoaded = mutationsList.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1 && n.className.includes('rapi-bundle-content')));
            if (pluginLoaded) {
              clearTimeout(timeoutId);
              observer.disconnect();
              runStickyLogic();
            }
          };
          const finalMutationObserver = new MutationObserver(enhancedMutationCallback);
          const timeoutId = setTimeout(() => {
            finalMutationObserver.disconnect();
            console.warn('MutationObserver 等待超时...');
            runStickyLogic();
          }, 5000);
        
          window.scrollTo(0, 0);
          finalMutationObserver.observe(formWrapper, { childList: true });
        });
      }

      /**
       * 设置观察目标 - 为交叉观察器设置要观察的DOM元素
       * 用于检测主产品表单是否在视口中可见
       */
      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      /**
       * 检查设备 - 设置粘性按钮的高度
       * 根据当前设备调整按钮高度并更新CSS变量
       * @param {Event} e - 事件对象
       */
      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      /**
       * 禁用变体默认选择 - 清空变体选择器的默认值
       * 当URL中没有变体参数且产品有多个变体时调用
       */
      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }


      /**
       * 与主产品表单同步 - 监听变体变化事件并同步变体选择
       * 确保粘性按钮的变体选择与主产品表单保持一致
       */
      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async (variant) => {
          if (variant) variantInput.value = variant.id;
        });
      }

      /**
       * 设置粘性按钮高度 - 更新CSS变量和全局设置中的按钮高度
       * 用于响应式布局和移动端适配
       */
      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
